import { useGetOne } from "./useGetOne";
import { Amend } from "../api/amend";
import { SpotContractAmend } from "../api/spot_contract_amend";

export const useAmend = (id: number | undefined) => useGetOne<Amend>("amends", id);
export const useSpotContractAmend = (id: number | undefined) =>
  useGetOne<SpotContractAmend>("spot_contract_amends", id);
